/* eslint-disable @typescript-eslint/no-unused-vars */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import authAPI from '../../../../api/authAPI'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [isSubmit, setSubmit] = useState(false)
  const [isChangePass, setChangePass] = useState(false)
  const [message, setMessage] = useState(null)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [tokenData, setTokenData] = useState('')
  const navigate:any = useNavigate()
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.email)
        // authAPI
        //   .resetPassRequest({email: values?.email})
          .then((res: any) => {
            console.log(res?.data)
            if (res?.data?.success) {
              setHasErrors(false)
              setLoading(false)
              setSubmit(true)
              setTokenData(res?.data?.token)
              setMessage(res?.data?.message)

              // localStorage?.setItem('tempToken', res?.data?.token)
            }else{
              setHasErrors(true)
              setLoading(false)
              setSubmitting(false)
              setStatus('The login detail is incorrect')
              setMessage(res?.data?.message)
            }
          })
          .catch((err) => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
            setMessage(err?.response?.data?.message)
            localStorage?.removeItem('tempToken')
          })
      }, 1000)
    },
    // onSubmit: (values, {setStatus, setSubmitting}) => {
    //   setLoading(true)
    //   setHasErrors(undefined)
    //   // setTimeout(() => {
    //     requestPassword(values.email)
    //       .then(
    //         (res: any) => {
    //           console.log(res)
    //           if (res?.data?.success === true) {
    //             setHasErrors(false)
    //             setLoading(false)
    //             formik.resetForm()
    //             setIsSuccess(true)
    //             setMessage(res?.data?.message)
    //           } else {
    //             setIsSuccess(false)
    //           }
    //         },
    //         (err: any) => {
    //           console.log(err)
    //           if (err?.response?.data?.success === false) {
    //             setHasErrors(true)
    //             setLoading(false)
    //             setSubmitting(false)
    //             setMessage(err?.response?.data?.message)
    //             console.log(err?.response?.data?.message)
    //             setIsSuccess(false)
    //           }
    //         }
    //       )
    //       .catch(() => {
    //         setHasErrors(true)
    //         setLoading(false)
    //         setSubmitting(false)
    //         setIsSuccess(false)
    //         setStatus('The login detail is incorrect')
    //       })
    //   // }, 100)
    // },
  })

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100'
      style={{background: '#f3f3f3'}}
    >
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px d-flex justify-content-center flex-wrap'>
            <img
              src={toAbsoluteUrl('/media/logos/asteric-white.png')}
              alt='logo'
              height={80}
              className='mb-5'
            />
            <form
              className='form w-100 card p-10'
              noValidate
              id='kt_login_password_reset_form'
              onSubmit={formik.handleSubmit}
            >
              <div className='mb-0'>
                {/* begin::Title */}
                <h3 className='text-dark fw-bold mb-3'>Reset Password</h3>
                {/* end::Title */}
                <hr />
                {/* begin::Link */}
                {/* <div className='text-gray-500 fw-semibold fs-6'>
                  Enter your email to reset your password.
                </div> */}
                {/* end::Link */}
              </div>

              {/* begin::Title */}
              {hasErrors === true && (
                <div className='mb-lg-10 mt-lg-0 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>
                    {message 
                      ? message
                      : 'Sorry, looks like there are some errors detected, please try again.'}
                  </div>
                </div>
              )}

              {hasErrors === false && isSubmit === true && isChangePass === false && (
                <div className='mb-10 bg-light-info p-8 rounded'>
                  <div className='text-dark'>
                    We’ve just sent you an email, check your inbox for the password recovery email{' '}
                  </div>
                </div>
              )}
              {/* end::Title */}

              {/* begin::Form group */}
              {isSubmit === false && isChangePass === false && (
                <div className='fv-row mb-8'>
                  <label className='form-label text-gray-900 fs-6'>Email address</label>
                  <input
                    type='email'
                    placeholder='Enter your email address'
                    autoComplete='off'
                    {...formik.getFieldProps('email')}
                    className={clsx(
                      'form-control bg-transparent',
                      {'is-invalid': formik.touched.email && formik.errors.email},
                      {
                        'is-valid': formik.touched.email && !formik.errors.email,
                      }
                    )}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.email}</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* end::Form group */}
              {isSubmit === false && isChangePass === true && (
                <div className='fv-row mb-8'>
                  <label className='form-label text-gray-900 fs-6'>New password</label>
                  <input
                    type='password'
                    placeholder='Enter new password'
                    autoComplete='off'
                    {...formik.getFieldProps('email')}
                    className={clsx(
                      'form-control bg-transparent',
                      {'is-invalid': formik.touched.email && formik.errors.email},
                      {
                        'is-valid': formik.touched.email && !formik.errors.email,
                      }
                    )}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.email}</span>
                      </div>
                    </div>
                  )}

                  <label className='mt-3 form-label text-gray-900 fs-6'>
                    Confirm new password
                  </label>
                  <input
                    type='password'
                    placeholder='Confirm new password'
                    autoComplete='off'
                    {...formik.getFieldProps('email')}
                    className={clsx(
                      'form-control bg-transparent',
                      {'is-invalid': formik.touched.email && formik.errors.email},
                      {
                        'is-valid': formik.touched.email && !formik.errors.email,
                      }
                    )}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.email}</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* begin::Form group */}
              {isSubmit === false && isChangePass === false && (
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                  <button
                    type='submit'
                    id='kt_password_reset_submit'
                    className='btn me-4 w-100'
                    style={{background: '#454743', color: '#fff', borderRadius: 50}}
                  >
                    <span className='indicator-label'>Send password reset link</span>
                    {loading && (
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  {/* <Link to='/auth/login'>
                  <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-light'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Cancel
                  </button>
                </Link>{' '} */}
                </div>
              )}
              {isSubmit === false && isChangePass === true && (
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                  <button
                    type='button'
                    id='kt_password_reset_submit'
                    className='btn me-4 w-100'
                    style={{background: '#454743', color: '#fff', borderRadius: 50}}
                    onClick={() => {
                      setSubmit(false)
                      setChangePass(false)
                    }}
                  >
                    <span className='indicator-label'>Confirm change</span>
                    {loading && (
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  {/* <Link to='/auth/login'>
                  <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-light'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Cancel
                  </button>
                </Link>{' '} */}
                </div>
              )}
              {isSubmit === true && (
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                  <button
                    type='button'
                    onClick={() => {
                      // setSubmit(false)
                      // setChangePass(true)
                      navigate('/reset/token/'+tokenData)
                    }}
                    id='kt_password_reset_submit'
                    className='btn me-4 w-100'
                    style={{background: '#454743', color: '#fff', borderRadius: 50}}
                  >
                    <span className='indicator-label'>View inbox</span>
                    {loading && (
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  {/* <Link to='/auth/login'>
                  <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-light'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Cancel
                  </button>
                </Link>{' '} */}
                </div>
              )}
              {/* end::Form group */}
            </form>
            <div className='text-black-500 text-center fw-semibold fs-6 mt-5'>
              Remember your password?{' '}
              <Link to='/auth/login' style={{color: '#16C782'}}>
                Login here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
